export enum SwipeDirection {
    Up = '[SwipeDirection] Up',
    Down = '[SwipeDirection] Down'
}
